import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const updateIntegrationToolParamsSchema_ = z.object({
  type: createEnum(["BlueYonder"]),
});
export const updateIntegrationToolParamsSchema: z.ZodType<UpdateIntegrationToolParams> =
  updateIntegrationToolParamsSchema_;
export interface UpdateIntegrationToolParams
  extends z.infer<typeof updateIntegrationToolParamsSchema_> {}
